 import api from '../../api/api.js'
 import request from '../../api/request.js'
 /**
  * 	console.log("===34324324=4=23432")
		console.log(proxy.$store.state)
 
		let res = computed(()=>{
			return proxy.$store.state.user.count
		})

	 
		// proxy.$store.dispatch('increment')
		proxy.$store.commit('increment')
  */

export default {
  state: ()=>{
    return {
      companyList:[],
      listProduct:[],
      listProtocol:[],
      isInit:false
    }
  },
  mutations: {
    initCompanyList (state,list) {
      state.companyList=list
    },
    initProduct (state,list) {
      state.listProduct=list
    },
    initProtocol (state,list) {
      state.listProtocol=list
    }
  },
  actions: {
    async getCompanyList ({ commit,state }) {
      if(state.companyList.length==0){
        const res = await new request(api.m().company_listCom,{}).modepost()
        if(res.data.status==200){
          commit('initCompanyList',res.data.data)
        }
        return state.companyList
      }else{
        // console.log("store cache"+state.companyList)
        return state.companyList
      }
    },

    async getListProtocol ({ commit,state }) {
      if(state.listProtocol.length==0){
        const res = await new request(api.m().proxy.$urls.m().product_listAll,{}).modepost()
        if(res.data.status==200){
          commit('initProduct',res.data.data.listPro)
          commit('initProtocol',res.data.data.listXy)
        }
        return state.listProtocol
      }else{
        return state.listProtocol
      }
    },

    async getListProduct ({ commit,state }) {
      if(state.listProduct.length==0){
        const res = await new request(api.m().product_listAll,{}).modepost()
        if(res.data.status==200){
          commit('initProduct',res.data.data.listPro)
          commit('initProtocol',res.data.data.listXy)
        }
        return state.listProduct
      }else{
        // console.log("store cache"+state.companyList)
        return state.listProduct
      }
    },
 
  },
  getters: {

    //  // 获取企业列表
    // getCompanyList(state) {
    //   return state.messages.filter(message => message.isRead);
    // },
    // // 获取协议列表
    // getListProtocol(state)  {
    //   return state.messages.find(message => message.id === id);
    // },
    // // 获取产品列表
    // getListProduct(state) {
    //   return state.messages.find(message => message.id === id);
    // }

  }

};


